<script lang="ts">
    import { onMount } from 'svelte';
    import { configService } from '$lib/services';
    import { recaptchaService } from '$lib/services/recaptcha';

    import type { OAuthOneTap } from '@api/types';
    import { oauthOneTap } from '@api/user';
    import { globalStore } from '@components/stores';
    import type { GlobalStoreState } from '@components/stores/global/types';
    import { toastsStore } from '@components/ui/toasts';
    import { Cookie } from '@shared/cookies';
    import { getCookie } from '@utils/cookies';

    import s from './wrapper.module.css';

    recaptchaService?.setBodyClassName(s.disableRecaptcha);

    onMount(() => {
        let isOneTapShowed = false;
        return globalStore.subscribe((state: GlobalStoreState) => {
            if (state.isCookiesAllowed && !isOneTapShowed) {
                isOneTapShowed = true;
                const cookiesAllowedAt = getCookie(Cookie.CookiesAllowedAt);
                import('$lib/services/oneTap').then(({ oneTapService }) => {
                    oneTapService.show(configService.get('googleClientId'), async (jwt: string) => {
                        const res = await oauthOneTap(jwt, cookiesAllowedAt);
                        if ((res.data as OAuthOneTap)?.redirectUrl) {
                            window.location.href = (res.data as OAuthOneTap).redirectUrl;
                        } else {
                            toastsStore.error((res.error as unknown as Error)?.message ?? 'Unknown error');
                        }
                    });
                });
            }
        });
    });
</script>

<slot />
